export default (theme) => ({
  avatarBackground: {
    backgroundColor: theme.palette.primary.main,
    position: 'relative'
  },
  avatar: {
    position:'absolute',
    top: 3,
    left: 3
  },
  avatarContent: {
    width: ['fit-content', '!important']
  }
});
